function GeoUtil() {
	// Static data
	var DEV_KEY = '7b20e4d47b1ac8497da262cf2f85c36d';
	var PROD_KEY = 'e58ef3c642ff15008f4f23f0090e00e6';
	var DATA_KEY = 'ip_data';
	var EXPIRATION_KEY = DATA_KEY+'_expiration';
	var EXPIRATION_DAYS = 7;

	// Dynamic data
	var IPSTACK_API_KEY;
	var IPSTACK_BASE_URL;

	// Helper function
	function establishInitials() {
		var isProd = window.cj.environment === 'prod';
		IPSTACK_API_KEY = isProd ? PROD_KEY : DEV_KEY;
		IPSTACK_BASE_URL = window.location.protocol + '//api.ipstack.com/';
	}

	function fetchGeoIP() {
		return new Promise(function(resolve, reject) {
			establishInitials();

			// The + is to actually make it a number vs parseInt
			var expiration = +localStorage.getItem(EXPIRATION_KEY);
			var now = Math.floor(Date.now() / 1000);
			var expired = (now > expiration);

			var ipData = localStorage.getItem(DATA_KEY);

			if (ipData) {
				try {
					ipData = JSON.parse(ipData);
				} catch (e) {
					ipData = null;
				}
			}

			if (ipData && !expired) {
				// Resolve with local storage value:
				resolve(ipData);
			} else {
				// Limited API queries per month (ipstack.com/usage).
				// Once reached, all requests will 403 until quota is cleared.
				var ipApiUrl = IPSTACK_BASE_URL + 'check?access_key=' + IPSTACK_API_KEY;

				fetch(ipApiUrl)
					.then(function(res) { return res.json(); })
					.then(function(ipData) {
						if (ipData.error && ipData.error.info) {
							return reject(ipData.error.info);
						}

						// Save locally & set expiration time:
						var expDate = new Date();
						var newExpiration = expDate.setDate(expDate.getDate() + EXPIRATION_DAYS);
						newExpiration = Math.floor(newExpiration / 1000);
						localStorage.setItem(DATA_KEY, JSON.stringify(ipData));
						localStorage.setItem(EXPIRATION_KEY, newExpiration);

						// Resolve with newly fetched value:
						resolve(ipData);
					})
					// Dont throw here — just reject
					// Caller should be able to catch & handle as they see fit
					.catch(reject);
			}
		});
	}

	function fetchCountryCode() {
		return new Promise(function(resolve, reject) {
			fetchGeoIP()
				.then(function(data) {
					resolve(data && data.country_code);
				})
				.catch(reject);
		});
	}

	return {
		fetchGeoIP: fetchGeoIP,
		fetchCountryCode: fetchCountryCode,
	};
}

// Once we extinguish the usage of this
if (typeof require === 'function' && typeof exports !== 'undefined') {
	module.exports = GeoUtil();
} else {
	define([], GeoUtil);
}
